import { Link } from 'react-router-dom';
import { DocumentFile, DocumentCategory } from 'modules/types/Document';
import { DocumentListItem } from './styled';
import { NavigationAndActionDownload } from '../../ui/icons';
import { Button, ButtonType, Subtitle, theme } from '../../ui';

export const AllowedDocumentFormats = '.doc, .docx, .pdf';

export interface ModalState {
  isOpen: boolean;
  documentCategory?: DocumentCategory;
}

export interface Category {
  documentCategory: DocumentCategory;
  displayName: string;
}

export const getDocumentListItem = (document: DocumentFile) => (
  <DocumentListItem key={document.name}>
    <Button
      type={ButtonType.Icon}
      icon={<NavigationAndActionDownload />}
      color={theme.colors.primaryP3}
      hoverColor={theme.colors.primaryP1}
    />
    <Link to={document.uri}>
      <Subtitle>{document.name}</Subtitle>
    </Link>
  </DocumentListItem>
);

export const removeDuplicates = (array: File[]): File[] =>
  array.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.name === value.name),
  );
